import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
              精彩视频
            </h2>
            <p className="text-sm text-foreground-500">热门综艺节目一网打尽</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-200">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 mb-1.5">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views} 次观看
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaData.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="group flex flex-col sm:flex-row rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200"
            >
              <div className="relative w-full sm:w-64 flex-shrink-0 aspect-video sm:aspect-auto overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-200">
                    <i className="ri-play-fill text-primary-500 text-lg ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full w-fit mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm font-medium text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views} 次观看
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}